import { render, staticRenderFns } from "./NavigationLabel.vue?vue&type=template&id=5880c4b7&scoped=true&"
import script from "./NavigationLabel.vue?vue&type=script&lang=js&"
export * from "./NavigationLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880c4b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VListItem,VTooltip})
